<form [formGroup]="specBox3FormGroup">
    <div formGroupName="specificatieBox3">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    <p>Rendementsgrondslag (a)</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="rendementsGrondslag"
                            id="rendementsGrondslag"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
            <div
                    *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        Af: Heffingsvrij vermogen
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="heffingsvrijVermogenAangever"
                                id="heffingsvrijVermogenAangever"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
            <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > 0 &&
                specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        Af: Heffingsvrij vermogen partner
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="heffingsvrijVermogenPartner"
                                id="heffingsvrijVermogenPartner"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
            <div
                    *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > 0">
                <div class="row">
                    <div class="col col-1">
                        <b>Grondslag sparen en beleggen</b>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="grondslagSparenEnBeleggen"
                                placeholder="0"
                                id="grondslagSparenEnBeleggen1"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="space20"></div>

<form [formGroup]="specBox3FormGroup">
    <div formGroupName="specificatieBox3">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    Fictief rendement
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="inkomenBox3"
                            placeholder="0"
                            id="inkomenBox3"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="berekening.partnerBerekening === undefined">
    <form [formGroup]="this.specBox3FormGroup">
        <div formGroupName="specificatieBox3">
            <div formGroupName="opbouw">
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > 0">
                    <div class="row">
                        <div class="col col-1">
                            <p>Grondslag sparen en beleggen</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    placeholder="0"
                                    formControlName="grondslagSparenEnBeleggen"
                                    id="grondslagSparenEnBeleggen2"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-1">
                        <p>Rendementsgrondslag</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementsGrondslag"
                                id="rendementsGrondslag2"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>
    <form [formGroup]="this.box3BerekeningenFormGroup">
        <div class="row">
            <div class="col col-1">
                <p>Grondslag t.o.v. rendementsgrondslag</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control
                        [decimals]="2"
                        align="right"
                        class="custom-input-150"
                        formControlName="percentageAangeverRendementsgrondslagZonderPartner"
                        id="percentageAangeverRendementsgrondslagZonderPartner"
                        prefix="%"
                ></snelstart-ui-number-form-control>
            </div>
            <div class="col-2"></div>
            <div class="col-4"></div>
        </div>
    </form>
    <form [formGroup]="specBox3FormGroup">
        <div formGroupName="specificatieBox3">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1 pt-1">
                        <p><b>Fictief voordeel uit sparen en beleggen</b> (rendement
                            € {{ this.specBox3FormGroup.get('specificatieBox3')?.get('opbouw')?.get('inkomenBox3')?.value  }}
                            x {{ this.box3BerekeningenFormGroup.get('percentageAangeverRendementsgrondslagZonderPartner')?.value }}
                            %)</p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3" style="font-weight: bold;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150 pt-1"
                                formControlName="voordeelSparenEnBeleggenVoorVermindering"
                                id="voordeelUitSparenEnBeleggen3"
                                prefix="€"
                                style="font-weight: bold;"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="berekening.partnerBerekening !== undefined">
    <form [formGroup]="this.box3BerekeningenFormGroup">
        <div class="row">
            <div class="col col-1">
                <p>Grondslag t.o.v. rendementsgrondslag (b / a)</p>
            </div>
            <div class="col-2"></div>
            <div class="col-2">
                <snelstart-ui-number-form-control
                        [decimals]="2"
                        align="right"
                        class="custom-input-150"
                        formControlName="percentageAangeverRendementsgrondslagZonderPartner"
                        id="percentageAangeverRendementsgrondslagZonderPartner"
                        prefix="%"
                ></snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </form>
    <form [formGroup]="specBox3FormGroup">
        <div formGroupName="specificatieBox3">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1 pt-1">
                        <b>Fictief voordeel uit sparen en beleggen</b>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3" style="font-weight: bold;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150 pt-1"
                                formControlName="totaalFictiefVoordeel"
                                id="totaalFictiefVoordeel"
                                prefix="€"
                                style="font-weight: bold;"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>
</div>

@if (incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement) {
    <form [formGroup]="specOWRFormGroup">
        <div formGroupName="specificatieOwr">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col col-1">
                        <b>Werkelijk voordeel sparen en beleggen</b>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="werkelijkRendement"
                                id="werkelijkRendement"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </form>

    <div *ngIf="incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement">
        Voor de box 3-belasting wordt uitgegaan van het laagste voordeel.
        <div class="space40"></div>
    </div>
}

<div *ngIf="berekening.partnerBerekening !== undefined">

    <div class="space20"></div>

<!--     KOPTEKSTEN -->
    <div class="left">
        <div class="row">
            <div class="pt-2" style="width: 395px;">
            </div>
            <div class="pe-2" style="width: 150px; text-align: center;">
                <p>Aandeel grondslag box 3 via verdeling</p>
            </div>
            <div class="ps-1 pe-2" class="pe-2" style="width: 185px; text-align: center;">
                <p>Aandeel grondslag / rendementsgrondslag</p>
            </div>
            <div class="ps-5 " class="pe-2" style="width: 155px; text-align: center;">
                <p>Aandeel <br/>in procenten</p>
            </div>
            <div class="ps-4" style="width: 160px; text-align: center;">
                <p>Inkomen sparen & beleggen (box 3)</p>
            </div>
        </div>
    </div>

    <!-- AANGEVER -->
    <div class="left">
        <div class="row">
            <div class="me-2 pt-2" style="width: 375px;">
                <b>Aandeel aangever</b>
            </div>
            <div class="me-2" style="width: 150px;">
                <form [formGroup]="verdelingFormGroup">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150 pt-1 pe-2"
                            formControlName="aandeelAangeverGrondslagSparenEnBeleggen"
                            id="aandeelAangeverGrondslagSparenEnBeleggen1"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="me-2 d-flex justify-content-center align-items-center disabled-aandeel pe-2"
                 style="width: 175px; border-bottom-style: double;">
                {{ this.gecombineerdeWaardeAangever }}
            </div>
            <div class="me-2 d-flex justify-content-center align-items-center disabled-percentage pe-2"
                 style="width: 130px;">
                <div *ngIf="this.verdelingFormGroup.get('aandeelAangeverGrondslagSparenEnBeleggen')?.value !== 0">
                    {{ this.box3BerekeningenFormGroup.get('percentageAangeverRendementsgrondslag')?.value }}
                    %
                </div>
                <div *ngIf="this.verdelingFormGroup.get('aandeelAangeverGrondslagSparenEnBeleggen')?.value === 0">
                    0,00 %
                </div>
            </div>
            <div style="width: 150px;">
                <form [formGroup]="berekeningFormGroup">
                    <div formGroupName="box3">
                        <div formGroupName="opbouwInkomen">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150 pt-1 pe-2"
                                    formControlName="voordeelUitSparenEnBeleggen"
                                    id="voordeelUitSparenEnBeleggen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- PARTNER -->
    <div class="left">
        <div class="row">
            <div class="me-2 pt-2" style="width: 375px;">
                <b>Aandeel partner</b>
            </div>
            <div class="me-2" style="width: 150px;">
                <form [formGroup]="verdelingFormGroup">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150 pt-1 pe-2"
                            formControlName="aandeelPartnerGrondslagSparenEnBeleggen"
                            id="aandeelPartnerGrondslagSparenEnBeleggen1"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="me-2 d-flex justify-content-center align-items-center disabled-aandeel pe-2"
                 style="width: 175px;">
                {{ this.gecombineerdeWaardePartner }}
            </div>
            <div class="me-2 d-flex justify-content-center align-items-center disabled-percentage pe-2"
                 style="width: 130px;">
                <div *ngIf="this.verdelingFormGroup.get('aandeelPartnerGrondslagSparenEnBeleggen')?.value !== 0">
                    {{ this.box3BerekeningenFormGroup.get('percentagePartnerRendementsgrondslag')?.value }}
                    %
                </div>
                <div *ngIf="this.verdelingFormGroup.get('aandeelPartnerGrondslagSparenEnBeleggen')?.value === 0">
                    0,00 %
                </div>
            </div>
            <div style="width: 150px;">
                <form [formGroup]="berekeningPartnerFormGroup">
                        <div formGroupName="box3">
                            <div formGroupName="opbouwInkomen">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150 pt-1 pe-2"
                                        formControlName="voordeelUitSparenEnBeleggen"
                                        id="voordeelUitSparenEnBeleggenPartner"
                                        placeholder="0"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
